import React, { useEffect, useState } from "react";
import axios from "axios";
import { useOutletContext, useNavigate, useParams } from "react-router-dom";
import { Bar, Line, Doughnut } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import html2canvas from "html2canvas";
import he from "he";

Chart.register(...registerables, ChartDataLabels);

function Newsletter() {
  const { setGlobalLoading, token } = useOutletContext();
  const { id } = useParams();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const [data, setData] = useState(null);
  const [actualTarget, setactualTarget] = useState(null);
  const [targetAchieved, setTargetchieved] = useState(null);
  const [last_revenue, setlast_revenue] = useState(null);
  const [prevMonthName, setprevMonthName] = useState(null);
  const [year, setYear] = useState(() => {
    let currentYear = new Date().getFullYear();
    if (new Date().getMonth() == 0) {
      currentYear = new Date().getFullYear() - 1;
    }
    return [currentYear, currentYear - 1];
  });
  const [growth, setgrowth] = useState(null);
  const [netgrowth, setnetgrowth] = useState(null);
  const [currentNetAdd, setcurrentNetAdd] = useState(null);
  const [lastNetAdd, setlastNetAdd] = useState(null);
  const [weeks, setweeks] = useState([]);
  const [weektarget, setweektarget] = useState([]);
  const [weekachieve, setweekachieve] = useState([]);
  const [sector, setsector] = useState([]);
  const [sectorRevenue, setsectorRevenue] = useState([]);
  const [region, setregion] = useState([]);
  const [regionRevenue, setregionRevenue] = useState([]);
  const [hasSent, setHasSent] = useState(null);
  useEffect(() => {
    const month_newsletter = async (id) => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/newsletter/monthly_newsletter/${id}`,
        );

        setData(response.data);
        setHasSent(id);
        const target = response.data.sector_revenue.reduce(
          (sum, item) => sum + Number(item.total_amount),
          0,
        );
        const target1 = target.toFixed(0);
        const total_target = response.data.target;
        setactualTarget(target1);
        const lastrevenue = response.data.last_time_revenue[0].amount;
        setlast_revenue(lastrevenue);
        setprevMonthName(response.data.prevMonthName);
        const growth =
          (((target - lastrevenue) / lastrevenue) * 100).toFixed(2) || 0;
        setgrowth(growth);
        const net_add_current =
          response.data.net_add_current_year[0].net_add_current_year;
        const net_add_last =
          response.data.net_add_last_year[0].net_add_last_year;
        setcurrentNetAdd(net_add_current);
        setlastNetAdd(net_add_last);
        const netaddgrowth =
          (((net_add_current - net_add_last) / net_add_last) * 100).toFixed(
            2,
          ) || 0;
        setnetgrowth(netaddgrowth);
        let formatted;
        if (target >= 10000000) {
          formatted = `${(target / 10000000).toFixed(2)} Cr`;
        } else {
          formatted = `${(target / 100000).toFixed(2)} Lakh`;
        }
        setTargetchieved(formatted);
        const weekdata = response.data.currentYearweekdata;
        const weeksArray = [];
        const weekTargetsArray = [];
        const weekAchieveArray = [];
        Object.entries(weekdata).forEach(([weekLabel, amount], index) => {
          weeksArray.push(weekLabel); // or setweeks(weekLabel) if you want "week 1", etc.
          weekTargetsArray.push(Math.round(total_target / 52));
          weekAchieveArray.push(amount);
        });
        setweeks(weeksArray);
        setweektarget(weekTargetsArray);
        setweekachieve(weekAchieveArray);
        const sector_revenue = response.data.sector_revenue;
        const sector = [];
        const sector_value = [];
        sector_revenue.forEach((value, index) => {
          sector.push(value.industry_name);
          sector_value.push(value.total_amount);
        });
        setsector(sector);
        setsectorRevenue(sector_value);
        const region_revenue = response.data.region_revenue;
        const region = [];
        const region_value = [];
        region_revenue.forEach((value, index) => {
          region.push(value.region_name);
          region_value.push(value.total_amount);
        });
        setregion(region);
        setregionRevenue(region_value);
      } catch (error) {
        console.log(error);
      } finally {
      }
    };
    month_newsletter(id);
  }, [id]);

  useEffect(() => {
    if (hasSent) {
      setTimeout(() => {
        // takeFullScreenshot();
      }, 2000);
    }
  }, [hasSent]);

  const takeFullScreenshot = async () => {
    try {
      setGlobalLoading(true);
      const node = document.getElementById("export-layout");
      const canvas = await html2canvas(node, {
        useCORS: true,
        scrollY: -window.scrollY, // ensures full rendering
        allowTaint: false,
        scale: 2,
      });
      const imgData = canvas.toDataURL("image/png");

      const response = await fetch(`${API_BASE_URL}/newsletter/send-email/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ img: imgData, id: id }),
      });
      if (response.status === 200) {
        alert("Email sent successfully");
      } else {
        alert("Failed to send email");
      }
    } catch (error) {
      setGlobalLoading(false);
      alert(error);
    } finally {
      setGlobalLoading(false);
    }
  };

  const netAddData = {
    labels: [`${prevMonthName} ${year[1]}`, `${prevMonthName} ${year[0]}`],
    datasets: [
      {
        backgroundColor: ["#67597a", "#544e61"],
        data: [Number(lastNetAdd), Number(currentNetAdd)],
      },
    ],
  };

  const NetAddchartOptions = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: `${netgrowth}% Growth in Net Add (Y-T-D)`,
        font: {
          family: "Georgia",
          size: 14,
          weight: "bold",
        },
        color: "#22444B",
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return (
              context.dataset.label +
              ": ₹" +
              context.raw.toLocaleString("en-IN")
            );
          },
        },
      },
      legend: {
        display: false,
      },
      datalabels: {
        anchor: "end",
        align: "start",
        color: "#ffffff",
        font: {
          weight: "bold",
          size: 12,
          family: "Georgia",
        },
        formatter: (value) => {
          if (value == null) return "";
          return `₹${value.toLocaleString("en-IN")}`;
        },
      },
    },
    scales: {
      y: {
        title: {
          display: true,
          text: "Net Add (INR)",
          font: {
            family: "Georgia",
            size: 14,
            weight: "bold",
          },
          color: "#22444B",
        },
        ticks: {
          callback: function (value) {
            return "₹" + value.toLocaleString("en-IN");
          },
          color: "#22444B",
        },
      },
      x: {
        ticks: {
          color: "#22444B",
        },
      },
    },
  };

  const revenueData = {
    labels: [`${prevMonthName} ${year[1]}`, `${prevMonthName} ${year[0]}`],
    datasets: [
      {
        backgroundColor: ["#67597a", "#544e61"],
        data: [Number(last_revenue), Number(actualTarget)],
      },
    ],
  };

  const weeklytarget = Math.floor(data?.target / 52, 0);

  const RevenuechartOptions = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: `${growth}% Revenue (B+P) Growth compared to last year same time (Y-T-D)`,
        font: {
          family: "Georgia",
          size: 14,
          weight: "bold",
        },
        color: "#22444B",
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return (
              context.dataset.label +
              ": ₹" +
              context.raw.toLocaleString("en-IN")
            );
          },
        },
      },
      legend: {
        display: false,
      },
      datalabels: {
        anchor: "end",
        align: "start",
        color: "#ffffff",
        font: {
          weight: "bold",
          size: 12,
          family: "Georgia",
        },
        formatter: (value) => {
          if (value == null) return "";
          return `₹${value.toLocaleString("en-IN")}`;
        },
      },
    },
    scales: {
      y: {
        title: {
          display: true,
          text: "Revenue (B+P, in INR)",
          font: {
            family: "Georgia",
            size: 14,
            weight: "bold",
          },
          color: "#22444B",
        },
        ticks: {
          callback: function (value) {
            return "₹" + value.toLocaleString("en-IN");
          },
          color: "#22444B",
        },
      },
      x: {
        ticks: {
          color: "#22444B",
        },
      },
    },
  };
  const lineData = {
    labels: weeks,
    datasets: [
      {
        label: `Weekly Net Add Target (${
          Math.round((weeklytarget / 10000000) * 100) / 100
        } Cr)`,
        data: weektarget,
        borderColor: "#e47a3e",
        backgroundColor: "transparent",
        tension: 0,
        borderWidth: 2,
      },
      {
        label: `Net Add ${data?.prevMonthName} '25`,
        data: weekachieve,
        borderColor: "#22444B",
        backgroundColor: "transparent",
        tension: 0,
        borderWidth: 2,
      },
    ],
  };
  const total = sectorRevenue.reduce((sum, val) => sum + val, 0);
  const donutOptions = {
    maintainAspectRatio: false,
    cutout: "50%", // For donut effect
    plugins: {
      title: {
        display: true,
        text: `Revenue By Sub-Sector`,
        font: {
          family: "Georgia",
          size: 14,
          weight: "bold",
        },
        color: "#22444B",
      },
      legend: {
        position: "bottom",
        labels: {
          generateLabels: (chart) => {
            const data = chart.data;
            const total = data.datasets[0].data.reduce(
              (sum, val) => sum + val,
              0,
            );
            return data.labels.map((label, i) => {
              const value = data.datasets[0].data[i];
              const percentage = ((value / total) * 100).toFixed(1);
              return {
                text: `${label} (${percentage}%)`, // 👈 add percentage here
                fillStyle: data.datasets[0].backgroundColor[i],
                strokeStyle: data.datasets[0].backgroundColor[i],
                hidden: isNaN(value) || chart.getDatasetMeta(0).data[i].hidden,
                index: i,
              };
            });
          },
        },
      },
      datalabels: {
        color: "#000",
        formatter: (value) => {
          const percentage = ((value / total) * 100).toFixed(1);
          return `${percentage}%`;
        },
        font: {
          weight: 100,
          size: 10,
        },
        // anchor: "end", // 👈 positions relative to arc
        // align: "end", // 👈 puts label outside the arc
        // offset: 10, // 👈 move a bit away from arc
      },
    },
  };
  const donutData = {
    labels: sector,
    datasets: [
      {
        data: sectorRevenue,
        backgroundColor: [
          "#ba7ba1",
          "#90BAAD",
          "#dec4a1",
          "#684756",
          "#96705B",
          "#065143",
          "#9e2b25",
          "#094074",
          "#4B2840",
        ],
      },
    ],
    borderWidth: 1,
  };

  const barOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      title: {
        display: true,
        text: `Revenue By Geography`,
        font: {
          family: "Georgia",
          size: 14,
          weight: "bold",
        },
        color: "#22444B",
      },
      legend: {
        display: false, // hide legend if not needed
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return context.label + ": ₹" + context.raw.toLocaleString("en-IN");
          },
        },
      },
      datalabels: {
        anchor: "end",
        align: "start",
        offset: -20,
        color: "#000",
        font: {
          weight: "bold",
          size: 12,
        },
        formatter: (value) => {
          return "₹" + value.toLocaleString("en-IN");
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          autoSkip: false, // show all country names
          maxRotation: 0, // tilt if name is long
          minRotation: 0,
          align: "center", // align label text to center of tick
          callback: function (value, index, values) {
            // return region[index]; // <- this line ensures country names show
            return region[index].length > 13
              ? region[index].slice(0, 13) + "…"
              : region[index];
          },
        },
      },
      y: {
        beginAtZero: true,
        grid: { display: true, color: "#ccc" },
        ticks: {
          callback: function (value) {
            return "₹" + value.toLocaleString("en-IN");
          },
        },
      },
    },
  };

  const barData = {
    labels: region,
    datasets: [
      {
        data: regionRevenue,
        backgroundColor: [
          "#ba7ba1",
          "#90BAAD",
          "#dec4a1",
          "#684756",
          "#96705B",
        ],
      },
    ],
  };

  const ucfirst = (str) => {
    if (!str) return "";
    const words = str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
    return words;
  };

  return (
    <>
      <a
        href="javascript:void(0)"
        onClick={() => takeFullScreenshot()}
        className="btn btn-primary"
        style={{ float: "right" }}
      >
        Send Email
      </a>
      <div
        id="export-layout"
        style={{
          fontFamily: "Georgia",
          background: "#E7E7E7",
          padding: 20,
        }}
      >
        <div style={{ background: "#fff", padding: 30 }}>
          {/* Banner */}
          <div
            style={{
              background: `url('${PINE_URL}/files/media/banner.png') no-repeat center/cover`,
              height: 300,
              padding: "40px 50px",
              color: "#fff",
            }}
          >
            <h1 style={{ color: "#E47A3E", fontSize: 55 }}>
              {ucfirst(data?.sector[0].group_name)} in {data?.prevMonthName}
            </h1>
            <h3 style={{ color: "#FFF", marginTop: 35 }}>MONTHLY NEWSLETTER</h3>
            <img
              src={`${PINE_URL}/files/media/logo_latest.png`}
              alt="Logo"
              style={{ width: "12%", marginTop: 20 }}
            />
          </div>

          {/* Summary */}
          <h2
            style={{
              color: "#E47A3E",
              textAlign: "center",
              marginTop: 30,
              fontfamily: "Georgia",
            }}
          >
            STATS OVER THE PAST MONTH
          </h2>

          <div
            style={{
              display: "flex",
              marginTop: 30,
              background: "#D6D6D6",
              padding: 20,
              justifyContent: "space-evenly",
              borderRadius: "35px",
            }}
          >
            <div
              style={{
                background: "#E47A3E",
                color: "#fff",
                padding: 10,
                borderRadius: "30px",
                width: "40%",
                textAlign: "center",
              }}
            >
              <strong>TARGET ACHIEVED (B+P) : {targetAchieved}</strong>
            </div>
            <div
              style={{ marginTop: "10px", fontSize: "medium", color: "black" }}
            >
              <strong>
                i.e., {`${((actualTarget / data?.target) * 100).toFixed(2)}%`}{" "}
                of overall target
              </strong>
            </div>
          </div>

          {/* Two Bar Charts */}
          <div style={{ display: "flex", gap: 40, marginTop: 40 }}>
            <div style={{ width: "50%" }}>
              <Bar
                data={netAddData}
                options={NetAddchartOptions}
                plugins={[ChartDataLabels]}
              />
            </div>
            <div style={{ width: "50%" }}>
              <Bar
                data={revenueData}
                options={RevenuechartOptions}
                plugins={[ChartDataLabels]}
              />
            </div>
          </div>

          {/* Line Chart */}
          <div style={{ width: "95%", height: 250, margin: "40px auto" }}>
            <h4 style={{ textAlign: "center" }}>
              Weekly Net Add - {prevMonthName}
            </h4>
            <Line
              data={lineData}
              options={{
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                  x: {
                    offset: true,
                    grace: "5%",
                    title: {
                      display: true,
                      text: "Week",
                    },
                    ticks: {
                      callback: function (val, index) {
                        return lineData.labels[index]; // Use week label
                      },
                      color: "#22444B",
                      padding: 5,
                    },
                    grid: { display: false },
                  },
                  y: {
                    beginAtZero: true,
                    grid: {
                      display: true,
                      color: "#ccc",
                    },
                    ticks: {
                      callback: function (value) {
                        return "₹" + value.toLocaleString("en-IN");
                      },
                    },
                  },
                },
                plugins: {
                  legend: {
                    position: "bottom",
                  },
                  tooltip: {
                    callbacks: {
                      label: function (context) {
                        return (
                          context.dataset.label +
                          ": ₹" +
                          context.raw.toLocaleString("en-IN")
                        );
                      },
                    },
                  },
                  datalabels: {
                    display: false, // If using chartjs-plugin-datalabels
                  },
                },
              }}
            />
          </div>

          {/* Highlights */}
          <div
            style={{
              backgroundColor: "#e47a3e",
              color: "#fff",
              padding: 40,
              display: "flex",
              justifyContent: "space-around",
              marginTop: 50,
            }}
          >
            <div
              style={{ fontSize: 45, fontWeight: "bold", textAlign: "center" }}
            >
              {targetAchieved}
              <div style={{ fontSize: 14, marginTop: 20 }}>
                Revenue (B+P) achieved as on {prevMonthName} {year[0]}
              </div>
            </div>
            <div
              style={{ fontSize: 45, fontWeight: "bold", textAlign: "center" }}
            >
              {growth}%
              <div style={{ fontSize: 14, marginTop: 20 }}>
                Revenue (B+P) growth compared to same time, last year
              </div>
            </div>
          </div>

          {/* Clients */}
          {/* Section: New clients in Consumer */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              backgroundColor: "#DBD8D6",
              padding: "40px",
              marginTop: "40px",
              flexWrap: "wrap",
            }}
          >
            {/* Left Side Text */}
            <div style={{ flex: "1 1 250px", marginRight: "40px" }}>
              <h2 style={{ fontSize: "32px", color: "#22444B", margin: 0 }}>
                #{data?.new_clients_count}
              </h2>
              <h3 style={{ fontSize: "20px", margin: "5px 0 0 0" }}>
                New clients in
              </h3>
              <h3
                style={{ fontSize: "26px", color: "#e47a3e", marginTop: "5px" }}
              >
                {ucfirst(data?.sector[0].group_name)}
              </h3>
            </div>

            {/* Right Side Logos Grid */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))",
                gap: "20px",
                flex: "3 1 400px",
              }}
            >
              {data?.company_logo.map((logo, idx) => (
                <img
                  key={idx}
                  src={`${PINE_URL}/files/companyLogo/${logo.logo}`}
                  alt={`Client ${idx + 1}`}
                  style={{
                    width: "100px",
                    height: "auto",
                    objectFit: "contain",
                    backgroundColor: "#fff",
                    padding: "10px",
                    borderRadius: "6px",
                  }}
                />
              ))}
            </div>
          </div>

          {/* Mandates List with Bullet Lines */}

          {data?.roles.length > 0 && (
            <div style={{ marginTop: 40, padding: 20 }}>
              <h3 style={{ fontSize: 22, marginBottom: 15 }}>
                Won the following mandates:
              </h3>
              <ul style={{ listStyle: "none", padding: 0 }}>
                {data?.roles.map((text, index) => (
                  <li
                    key={index}
                    style={{
                      position: "relative",
                      paddingLeft: 35,
                      fontSize: 20,
                      marginBottom: index !== data?.roles.length - 1 ? 20 : 0,
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        left: 0,
                        top: "7px",
                        width: 20,
                        height: 10,
                        backgroundColor: "#e47a3e",
                        borderRadius: "50px",
                      }}
                    ></span>
                    {he.decode(text.name || "")} {`(${text.company_name})`}
                    {index !== data?.roles.length - 1 && (
                      <hr
                        style={{
                          borderTop: "1px solid #ccc",
                          margin: "10px 0 0 0",
                        }}
                      />
                    )}
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Donut & Bar Chart */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              marginTop: 40,
            }}
          >
            <div style={{ width: 350, height: 350 }}>
              <Doughnut data={donutData} options={donutOptions} />
            </div>
            <div style={{ width: 450, height: 350 }}>
              <Bar data={barData} options={barOptions} />
            </div>
          </div>

          {/* Candidates */}

          {data?.candidates.length > 0 ? (
            <div
              style={{
                marginTop: 60,
                padding: 30,
                backgroundColor: "#fefefe",
                borderTop: "2px solid #e47a3e",
              }}
            >
              <h3
                style={{
                  fontFamily: "Georgia",
                  fontSize: 24,
                  color: "#22444B",
                  fontWeight: "bold",
                  textAlign: "center",
                  marginBottom: 30,
                }}
              >
                Candidates who joined this month :
              </h3>
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: 30,
                }}
              >
                {data?.candidates.map((candidate, idx) => (
                  <div key={idx} style={{ textAlign: "center", width: 180 }}>
                    <img
                      src={`${PINE_URL}/files/candidates/picture/${
                        candidate.userpic ? candidate?.userpic : "no-pic.png"
                      }`}
                      alt={candidate.candidate_name}
                      style={{
                        width: 120,
                        height: 120,
                        borderRadius: "50%",
                        objectFit: "cover",
                        border: "3px solid #e47a3e",
                      }}
                    />
                    <div
                      style={{
                        marginTop: 10,
                        fontWeight: "bold",
                        fontSize: 16,
                      }}
                    >
                      {candidate.candidate_name}
                    </div>
                    <div style={{ fontSize: 14, color: "#555" }}>
                      {candidate.role_name}, {candidate.company_name}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
}

export default Newsletter;
